import { h } from 'preact'
import classNames from 'clsx'

import LinkWrapper from '../link-wrapper'

import styles from './index.module.scss'

const YearLink = ({ children, className, href, ...props }) => {
  const p = {
    className: classNames(className, styles['a-year-link']),
    ...props,
  }

  return href ? (
    <LinkWrapper href={href} {...p}>
      {children}
    </LinkWrapper>
  ) : (
    <span {...p}>{children}</span>
  )
}

export default YearLink
